<template>
  <div id="app">
    <router-view />
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <cookie-banner />
  </div>
</template>

<script>
import CookieBanner from '@/app/components/CookieBanner.vue'

export default {
  name: 'App',
  components: {
    CookieBanner
  },
  mounted () {
    this.$router.beforeEach((to, from, next) => {
      this.$refs.topProgress.start()
      next()
    })

    this.$router.afterEach((to, from) => {
      this.$refs.topProgress.done()
      this.$refs.topProgress.done()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/App.vue